import { render } from "./z-task-readonly-info.vue?vue&type=template&id=2ec69e38&scoped=true"
import script from "./z-task-readonly-info.vue?vue&type=script&lang=js"
export * from "./z-task-readonly-info.vue?vue&type=script&lang=js"

import "./z-task-readonly-info.vue?vue&type=style&index=0&id=2ec69e38&lang=sass&scoped=true"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec69e38"]])

export default __exports__